import React from 'react';
export default (function (_a) {
    var jsonString = _a.jsonString, className = _a.className;
    return (React.createElement("pre", { className: className }, JSON.stringify(JSON.parse(jsonString), null, 4)));
});
